import { render, staticRenderFns } from "./email-notifications-form.vue?vue&type=template&id=c774b162&"
import script from "./email-notifications-form.vue?vue&type=script&lang=js&"
export * from "./email-notifications-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports